import { Routes, Route } from 'react-router-dom';
import CallAI from './components/CallAI';
import { LearnerRenderer } from './components/Learner';
const LegacyRouting = () => (
  <Routes>
    <Route path="callai/*" element={<CallAI />}></Route>
    <Route path="*" element={<LearnerRenderer />}></Route>
  </Routes>
);

export default LegacyRouting;
